import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { Divider, Drawer, Flex, Input } from "antd";
import * as React from "react";
import { useNavigate } from "react-router";
import { ProductSearch } from "../../../App.tsx";
import Typography from "../../typography/index.tsx";
import { InputStyled } from "../../utils/utils.tsx";

const Search = () => {
  const [open, setOpen] = React.useState(false);
  const { search, setSearch } = React.useContext(ProductSearch);
  const navigate = useNavigate();
  
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  // Раніше поле було disabled скрізь, окрім /collections/:id -- єдиного місця,
  // де хтось читав контекст пошуку. Тепер запит веде на /search, а той показує
  // ті самі результати products/filtered, що й категорії.
  const submit = () => {
    const q = (search || "").trim();
    if (!q) return;
    setOpen(false);
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };
  return (
    <div>
      <InputStyled
        placeholder="ПОШУК"
        variant="borderless"
        prefix={<SearchOutlined />}
        style={{ color: "black", width: "87px", padding: 0 }}
        maxLength={15}
        onClick={showDrawer}
      />
      <Drawer
        onClose={onClose}
        open={open}
        height={"80px"}
        closable={false}
        placement="top"
        extra={<p>extra</p>}
      >
        <Flex align="center">
          <SearchOutlined />
          <Input
            placeholder="ПОШУК ПО MADJO.COM"
            variant="borderless"
            suffix={<CloseOutlined onClick={() => setSearch("")} />}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onPressEnter={submit}
            style={{
              color: "black",
            }}
            maxLength={15}
            onClick={showDrawer}
          />
          <Typography onClick={submit} variant="uppercase" style={{ cursor: "pointer", paddingRight: "16px" }}>
            ЗНАЙТИ
          </Typography>
          <Typography onClick={onClose} variant="uppercase" style={{ cursor: "pointer" }}>
            ЗАКРИТИ
          </Typography>
        </Flex>
        <Divider style={{ margin: 0, backgroundColor: "#767D93" }} />
      </Drawer>
    </div>
  );
};

export default Search;
